import { BaseStore } from "../abstracts/store/base-store.abstract";
import { Deferred } from "./deferred";
import { SimpleEventDispatcher } from "strongly-typed-events";

export interface AdPlacement {
  id: string;
  element: HTMLElement;
  initialized: boolean;
  position: string;
  collapse: boolean;
  lazy: boolean;
  visibleChangeRefresh: boolean;
  split: string;
}

export abstract class AdsBase {
  static PUSHDOWN_INDEX = "7004";
  static POSITION_ATTRIBUTE = "data-position";
  static ADSPLIT_ATTRIBUTE = "data-split";
  static SELECTORS = {
    adSlots: "component-ad-unit:not(.initialized)",
    collapse: "ad-collapse",
    lazyLoad: "lazy-load",
    initialized: "initialized",
    refresh: "viewport-refresh",
  };

  protected intersection: IntersectionObserver | null = null;

  protected abstract store: BaseStore;
  protected abstract gpt: GPTUtilsBase;
  abstract init(): Promise<boolean>;
  abstract clear(): void;
  abstract handleMutationEvent(): void;
  abstract slotRendered(event: googletag.events.SlotOnloadEvent): void;
  abstract handleIntersectionUpdate(entries: IntersectionObserverEntry[]): void;
  protected abstract scanForSlots(node: HTMLElement | Document): void;
  abstract scan(): boolean;
  abstract cleanup(): void;
}

export interface SlotState {
  id: string;
  visible: boolean;
  displayed: boolean;
  rendered: boolean;
  slot: googletag.Slot;
  element: HTMLElement;
  visibleChangeRefresh: boolean;
}

export interface InfernoSlot extends SlotState {
  position_id: string;
  sizes?: number[][] | string;
}

export abstract class GPTUtilsBase {
  protected active = true;
  protected configuredSlots: { [k: string]: InfernoSlot } = {};
  protected pendingPromise: Deferred<boolean> | null = null;

  protected abstract pub?: googletag.PubAdsService;
  protected _onSlotRendered = new SimpleEventDispatcher<googletag.events.SlotRenderEndedEvent>();
  protected refreshInProgress = false;
  get onSlotRendered() {
    return this._onSlotRendered.asEvent();
  }

  abstract queue(fn: () => void): void;
  abstract init(): Promise<boolean>;
  abstract configurePubAdsService(): void;
  abstract enableServices(): Promise<void>;
  abstract setBaseTargeting(): void;
  abstract clearDisplayed(): void;
  abstract destroySlots(): void;
  abstract isRendered(position: string): boolean;
  abstract isSlotRenderEndedEvent(event: any): event is googletag.events.SlotRenderEndedEvent;
  abstract handleSlotRenderEnded(
    event:
      | googletag.events.ImpressionViewableEvent
      | googletag.events.SlotOnloadEvent
      | googletag.events.SlotRenderEndedEvent,
  ): void;
  abstract refreshAllVisibleAds(): void;
  abstract setupSlotTargeting(slot: googletag.Slot, position_id: string): void;
  abstract createSlot(
    id: string,
    position_id: string,
    element: HTMLElement,
    collapsible: boolean,
    visibleChangeRefresh: boolean,
    split: string,
  ): void;
  abstract resolveSlot(position_id: string): void;
  abstract setVisible(id: string, visible: boolean): void;
}
